import React from 'react';
import './OrdersTemplate.css';

const styles = {
  container: 'xs:w-[calc(100vw-3rem)] sm:w-[23rem] mx-2 bg-white shadow-sm sm:p-4 xs:p-2 mb-2', // Reduced width and padding for xs
  orderRow: 'flex items-center justify-between mb-1 xs:mb-2',
  orderId: 'text-sm xs:text-md font-bold pt-[4px] xs:pt-[6px]', // Smaller text and padding for xs
  status: 'ml-1 font-semibold text-xs sm:text-md ', // Smaller font for xs
  productName: 'text-lg xs:text-xl font-semibold mb-1 xs:mb-2', // Smaller text for xs
  buttonsContainer: 'flex items-center justify-between mt-2 xs:mt-3', // Reduced margin for xs
  actionButton: 'bg-blue-500 text-white text-xs xs:text-sm px-2 xs:px-4 py-1 xs:py-2 rounded-lg hover:bg-blue-700 cursor-pointer whitespace-nowrap', // Smaller padding and text
  reOpenButton: 'text-[#039118] text-xs xs:text-sm font-semibold px-2 xs:px-4 py-1 xs:py-2 bg-white hover:text-integrationRequestTextHover hover:bg-charmHover w-fit mx-auto rounded-full whitespace-nowrap', // Reduced font and padding
  closeButton: 'text-red text-xs xs:text-sm font-semibold px-2 xs:px-4 py-1 xs:py-2 bg-white hover:text-red hover:bg-charmHover w-fit mx-auto rounded-full whitespace-nowrap', // Reduced font and padding
  updateButton: 'text-yellow text-xs xs:text-sm font-semibold px-2 xs:px-4 py-1 xs:py-2 bg-white hover:text-integrationRequestTextHover hover:bg-charmHover w-fit mx-auto rounded-full whitespace-nowrap', // Reduced font and padding
  icon: 'mr-0.5 xs:mr-1', // Smaller margin for icon on xs
  user_email: 'overflow-scroll whitespace-nowrap'
};


const OrderTemplate = ({ order, updateOrderStatus, handleOpenMessagePanel }) => {

  // Function to format the creation date to local time
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  // Function to get the appropriate status class
  const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
      case 'pending':
        return 'orders-status-pending';
      case 'awaiting vendor action':
        return 'orders-status-awaiting-vendor';
      case 'awaiting user action':
        return 'orders-status-awaiting-user';
      case 'closed':
        return 'orders-status-closed';
      case 'legacy':
        return 'orders-status-legacy';
      default:
        return '';
    }
  };

  return (
    <div className={styles.container}>
      {/* Order ID and Status */}
      <div className={styles.orderRow}>
        <p className={styles.orderId}>ID: #{order.id}</p>
        <span className={`${styles.status} ${getStatusClass(order.status)}`}>{order.status}</span>
      </div>

      {/* Product Name */}
      <div className={styles.productName}>
        {order.product.name}
      </div>

      <div className={styles.user_email}>
        Practice Name: {order.practice_name}
      </div>

      {/* email */}
      <div className={styles.user_email}>
        {order.user_email}{order.practice_user_email}
      </div>


      {/* Buttons Row */}
      <div className={styles.buttonsContainer}>
        {order.status.toLowerCase() === 'closed' ? (
          <button className={styles.reOpenButton} onClick={() => updateOrderStatus(order.id, 'reopen')}>
            <div className='flex items-center'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-basket3" viewBox="0 0 16 16">
                <path d="M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 6h1.717L5.07 1.243a.5.5 0 0 1 .686-.172zM3.394 15l-1.48-6h-.97l1.525 6.426a.75.75 0 0 0 .729.574h9.606a.75.75 0 0 0 .73-.574L15.056 9h-.972l-1.479 6z" />
              </svg>
              <span className="ml-2">Re-Open</span>
            </div>
          </button>
        ) : (
          <button className={styles.closeButton} onClick={() => updateOrderStatus(order.id, 'close')}>
            <div className='flex items-center close-button-hover'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
              </svg>
              <span className="ml-2">Close Order</span>
            </div>
          </button>
        )}
        <button className={styles.updateButton} onClick={() => handleOpenMessagePanel(order)}>
          <div className='flex items-center'>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chat-left-dots" viewBox="0 0 16 16">
              <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
              <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
            </svg>
            <span className="ml-2">Reply</span>
          </div>
        </button>
      </div>

    </div>
  );
};

export default OrderTemplate;
